'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactUtils = require('react-utils');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _InputConstants = require('./InputConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UITextArea = _react2.default.createClass({
  displayName: 'UITextArea',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    className: _react.PropTypes.string,
    cols: _react.PropTypes.number,
    counter: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    placeholder: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool,
    resize: _react.PropTypes.bool,
    rows: _react.PropTypes.number,
    style: _react.PropTypes.object,
    styled: _react.PropTypes.bool.isRequired,
    _textAreaHeightStyle: _react.PropTypes.object,
    use: _react.PropTypes.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
    value: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      resize: true,
      styled: true,
      value: ''
    };
  },
  focus: function focus() {
    if (this.refs.textarea) {
      this.refs.textarea.focus();
    }
  },
  select: function select() {
    if (this.refs.textarea) {
      this.refs.textarea.select();
    }
  },
  getTextArea: function getTextArea() {
    return this.refs.textarea;
  },
  getClassName: function getClassName(_ref) {
    var className = _ref.className,
        counter = _ref.counter,
        error = _ref.error,
        resize = _ref.resize,
        styled = _ref.styled,
        use = _ref.use;

    return (0, _reactUtils.classNames)('form-control', 'private-form__control', 'private-text-area', className, _InputConstants.USE_CLASSES[use], {
      'private-text-area--with-counter': counter,
      'private-form__control--unstyled': !styled,
      'private-form__control--error': error,
      'private-text-area--no-resize': !resize
    });
  },
  getStyle: function getStyle(_ref2) {
    var _textAreaHeightStyle = _ref2._textAreaHeightStyle,
        style = _ref2.style;

    return _extends({}, _textAreaHeightStyle, style);
  },
  renderCounter: function renderCounter(_ref3) {
    var value = _ref3.value;

    var count = value ? value.length : 0;
    return _react2.default.createElement(
      'span',
      {
        className: 'private-text-area__counter',
        'aria-live': 'polite',
        'aria-atomic': 'false'
      },
      count === 1 ? _I18n2.default.text('salesUI.UITextArea.characterCounter.one', { count: count }) : _I18n2.default.text('salesUI.UITextArea.characterCounter.other', { count: count })
    );
  },
  renderTextarea: function renderTextarea(_ref4, _ref5) {
    var rest = _ref4.rest,
        value = _ref4.value;
    var computedClassName = _ref5.computedClassName,
        computedStyle = _ref5.computedStyle;

    return _react2.default.createElement('textarea', _extends({}, rest, {
      className: computedClassName,
      ref: 'textarea',
      style: computedStyle,
      value: value
    }));
  },
  render: function render() {
    var _props = this.props,
        _textAreaHeightStyle = _props._textAreaHeightStyle,
        className = _props.className,
        counter = _props.counter,
        error = _props.error,
        resize = _props.resize,
        style = _props.style,
        styled = _props.styled,
        use = _props.use,
        value = _props.value,
        rest = _objectWithoutProperties(_props, ['_textAreaHeightStyle', 'className', 'counter', 'error', 'resize', 'style', 'styled', 'use', 'value']);

    var computedClassName = this.getClassName({ className: className, counter: counter, error: error, resize: resize, styled: styled, use: use });
    var computedStyle = this.getStyle({ _textAreaHeightStyle: _textAreaHeightStyle, style: style });
    var renderedTextarea = this.renderTextarea({ rest: rest, value: value }, { computedClassName: computedClassName, computedStyle: computedStyle });

    if (counter) {
      return _react2.default.createElement(
        'div',
        { className: 'private-text-area__counter-wrapper' },
        renderedTextarea,
        this.renderCounter({ value: value })
      );
    }
    return renderedTextarea;
  }
});

exports.default = (0, _Controllable2.default)(UITextArea);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/input/UITextArea.js
// module id = 247
// module chunks = 0 1